const ENV = {
  prd: 'prd',
  stg: 'stg'
};
export const isProduction = process.env.ENV === ENV.prd;
export const isStaging = process.env.ENV === ENV.stg;
